<!-- 商品列表弹框 -->
<template>
  <div class="couponsProductDialog">
    <el-dialog
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :append-to-body="true"
      :visible.sync="isShow"
      width="446px"
      title="商品列表"
    >
      <el-row class="TeacherList">
        <el-col
          v-for="item of goodsList"
          :key="item.id"
          :span="24"
          class="teacherCell"
        >
          <div>
            <img :src="item.cover" class="cover" />
          </div>
          <div class="goods-content">
            <div class="goods-title">{{ item.name }}</div>
            <div class="goods-price">
              <div class="goodsPriceBox">
                <div class="AfterCouponPrice money-symbol AfterpriceColor">
                  <span class="AfterCouponPrice-title">券后价：</span>￥<span
                    class="money-num"
                    >{{ item.coupon_discount_price }}</span
                  >
                </div>
                <div class="couponPrice money-symbol priceColor">
                  <del>￥{{ item.price }}</del>
                </div>
              </div>
              <div
                class="to-buy"
                :class="{ disabled: item.count == 0 && item.infinite == 0 }"
                @click="toDetail(item)"
              >
                去抢购
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import tool from "@/kits/Tools.js";
import qs from "qs";
export default {
  name: "CouponsProductDialog",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    goodsList: {
      type: Array,
      default: () => [],
    },
    fans_id: {
      type: String | Number,
      default: "",
    },
    channel_id: {
      type: String | Number,
      default: "",
    },
  },
  computed: {
    isShow: {
      get() {
        return this.dialogVisible;
      },
      set() {
        this.close();
      },
    },
  },
  methods: {
    async collectRecordFn(id) {
      // 采集购买记录
      const params = {
        id,
        type: 1,
        fans_id: this.fans_id,
        channel_id: this.channel_id,
        ds_id: tool.getQueryString("ds_id"),
      };
      await this.axios.post(
        tool.baseUrl2() + "/api/goods/info",
        qs.stringify(params)
      );
    },
    async toDetail({ id, count, infinite, jump, payurl }) {
      if (jump === 1) {
        await this.collectRecordFn(id);
        window.open(payurl);
        return;
      }
      if (Number(count) === 0 && Number(infinite) === 0) {
        this.$message.closeAll();
        this.$message.warning("商品库存不足");
        return;
      }
      this.$emit("showGoodsQrCode", id);
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.TeacherList {
  width: 100%;
  min-height: 300px;
  max-height: 500px;
  overflow-y: auto;
  padding: 0 4px;
  box-sizing: border-box;
}
.TeacherList::-webkit-scrollbar {
  width: 4px;
  height: 8px;
  padding-left: 10px;
}
.TeacherList::-webkit-scrollbar-track {
  background: rgb(239, 239, 239);
  border-radius: 2px;
}
.TeacherList::-webkit-scrollbar-thumb {
  background: #bfbfbf;
  border-radius: 5px;
}
.TeacherList .teacherCell {
  /* width: 100%; */
  margin-bottom: 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #e6e9f0;
  border-radius: 6px;
  padding: 4px 10px 14px 4px;
  display: flex;
  align-items: center;
}
.TeacherList .teacherCell .cover {
  width: 72px;
  height: 72px;
  border-radius: 6px;
}
.TeacherList .teacherCell .goods-num {
  width: 30px;
}
.TeacherList .teacherCell.order {
  padding-bottom: 25px;
  border-bottom: 1px #eee solid;
}
.TeacherList .teacherCell .goods-content {
  margin-left: 12px;
  width: 100%;
  height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 8px 0;
  box-sizing: border-box;
}
.TeacherList .teacherCell .goods-content .goods-title {
  font-size: 14px;
  line-height: 20px;
  color: #202020;
  font-weight: 600;
  width: 182px;
  height: 20px;
  margin-bottom: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  white-space: normal !important;
  word-wrap: break-word;
}

.TeacherList .teacherCell .goods-price {
  display: flex;
  color: #f34718;
  font-weight: 700;
  align-items: flex-end;
  margin-top: 12px;
}
.TeacherList .teacherCell .money-symbol {
  font-size: 12px;
}
.TeacherList .teacherCell .money-num {
  font-size: 15px;
}
.TeacherList .teacherCell .to-buy {
  color: #f5f5f5;
  font-size: 12px;
  text-align: center;
  line-height: 25px;
  background: linear-gradient(294deg, #ff1f0f 0%, #ff8e5e 100%);
  margin-left: auto;
  cursor: pointer;
  width: 64px;
  border-radius: 13px;
}
.TeacherList .teacherCell .to-buy.disabled {
  background: #dddddd;
}
.TeacherList .teacherCell .num {
  height: 17px;
  font-size: 12px;
  color: #999999;
}
.goodsPriceBox {
  display: flex;
}
.AfterCouponPrice-title {
  color: #666666;
}
.AfterpriceColor {
  color: #ff0b0b;
}
.priceColor {
  color: #999999;
}
.couponPrice {
  display: flex;
  align-items: flex-end;
  margin-left: 2px;
}
::v-deep .el-dialog__body {
  padding-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/couponsComponents/couponsProductDialog.vue